import { render, staticRenderFns } from "./MoneyBoxNewForm.vue?vue&type=template&id=53196048"
import script from "./MoneyBoxNewForm.vue?vue&type=script&lang=js"
export * from "./MoneyBoxNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports